import { getInfoUserLocalStorage } from '@/utils/handlers';
import { isRolePartner } from '@/views/pages/require/handlers.js';

const configHelperCampaign = {
    configTable: {
        nameTable: 'ListCampaign',
        widthAction: 200,
        headers: [
            {
                label: '',
                backgroundColor: '#ffe599',
                rowSpan: 1,
                colSpan: 1,
                sub_headers: [
                    {
                        label: 'CP 番号',
                        backgroundColor: '#fff2cc',
                        width: 100
                    },
                    {
                        label: 'キャンペーン名',
                        backgroundColor: '#fff2cc',
                        width: 290
                    }
                ],
                width: 390
            },
            {
                label: '担当',
                backgroundColor: '#ffe599',
                sub_headers: [
                    {
                        label: '営業担当',
                        backgroundColor: '#fff2cc',
                        width: 225
                    },
                    {
                        label: 'ディレクターメイン',
                        backgroundColor: '#fff2cc',
                        width: 225
                    },
                    {
                        label: 'ディレクターサブ',
                        backgroundColor: '#fff2cc',
                        width: 160
                    }
                ],
                width: 610
            },
            {
                label: '期間',
                backgroundColor: '#ffe599',
                sub_headers: [
                    {
                        label: 'キャンペーン開始年月日（時間）',
                        backgroundColor: '#fff2cc',
                        width: 230
                    },
                    {
                        label: 'キャンペーン終了年月日（時間）',
                        backgroundColor: '#fff2cc',
                        width: 230
                    },
                    {
                        label: '事務局開始日（時間）',
                        backgroundColor: '#fff2cc',
                        width: 230
                    },
                    {
                        label: '事務局終了年月日（時間）',
                        backgroundColor: '#fff2cc',
                        width: 230
                    }
                ],
                width: 920
            },
            {
                label: 'ステータス',
                backgroundColor: '#ffe599',
                sub_headers: [
                    {
                        label: 'ステータス',
                        backgroundColor: '#fff2cc',
                        width: 170
                    }
                ],
                width: 170
            },
            {
                label: '種類',
                backgroundColor: '#ffe599',
                sub_headers: [
                    {
                        label: '種別',
                        backgroundColor: '#fff2cc',
                        width: 70
                    },
                    {
                        label: '応募種別',
                        backgroundColor: '#fff2cc',
                        width: 360
                    }
                ],
                width: 430
            },
            {
                label: '顧客',
                backgroundColor: '#ffe599',
                sub_headers: [
                    {
                        label: 'エンドクライアント',
                        backgroundColor: '#fff2cc',
                        width: 150
                    },
                    {
                        label: '発注元（代理店）',
                        backgroundColor: '#fff2cc',
                        width: 150
                    }
                ],
                width: 300
            },
            {
                label: '当選者数',
                backgroundColor: '#ffe599',
                sub_headers: [
                    {
                        label: '当選者数',
                        backgroundColor: '#fff2cc',
                        width: 100
                    }
                ],
                width: 100
            },
            {
                label: 'LPサイト',
                backgroundColor: '#ffe599',
                sub_headers: [
                    {
                        label: 'LPサイト',
                        backgroundColor: '#fff2cc',
                        width: 220
                    }
                ],
                width: 220
            },
            {
                label: 'お問い合わせ関連',
                backgroundColor: '#a4c2f4',
                sub_headers: [
                    {
                        label: '電話',
                        backgroundColor: '#c9daf8',
                        width: 120
                    },
                    {
                        label: 'メール',
                        backgroundColor: '#c9daf8',
                        width: 220
                    },
                    {
                        label: 'パートナー',
                        backgroundColor: '#c9daf8',
                        width: 370
                    },
                    {
                        label: 'メモ',
                        backgroundColor: '#c9daf8',
                        width: 220
                    },
                    {
                        label: 'エスカレメイン',
                        backgroundColor: '#c9daf8',
                        width: 130
                    },
                    {
                        label: 'エスカレサブ',
                        backgroundColor: '#c9daf8',
                        width: 130
                    }
                ],
                width: 750
            },
            {
                label: '受注範囲',
                backgroundColor: '#b6d7a8',
                sub_headers: [
                    {
                        label: '受注範囲',
                        backgroundColor: '#d9ead3',
                        width: 300
                    }
                ],
                width: 300
            },
            {
                label: 'パートナー・ツール',
                backgroundColor: '#b6d7a8',
                sub_headers: [
                    {
                        label: '事務局パートナー',
                        backgroundColor: '#d9ead3',
                        width: 150
                    },
                    {
                        label: '利用ツール',
                        backgroundColor: '#d9ead3',
                        width: 200
                    }
                ],
                width: 350
            }
        ]
    },

    getConfigPage() {
        return {
            total: 0,
            limit: 30,
            page: 1
        };
    },

    getConfigModalListPrv() {
        return {
            title: '',
            model: false,
            scrollable: true,
            hideFooter: false,
            centered: false,
            size: 'xl'
        };
    },

    getDateFrom() {
        return {
            total_win_from: '',
            total_inquiry_from: '',
            quantity_for_event_prize: '',
            number_of_win_prize: '',
            total_application_from: '',
            target_product_amount_from: '',
            target_product_quantity_from: '',
            target_product_total_amount_from: '',
            distribution_total_amount_from: '',
            campaign_end_date: '',
            campaign_end_date_y: '',
            campaign_end_date_m: '',
            campaign_end_date_d: '',

            campaign_start_date: '',
            campaign_start_date_y: '',
            campaign_start_date_m: '',
            campaign_start_date_d: '',

            secretariat_start_date: '',
            secretariat_start_date_y: '',
            secretariat_start_date_m: '',
            secretariat_start_date_d: '',

            secretariat_end_date: '',
            secretariat_end_date_y: '',
            secretariat_end_date_m: '',
            secretariat_end_date_d: '',

            receipt_expiration_start_date: '',
            receipt_expiration_start_date_y: '',
            receipt_expiration_start_date_m: '',
            receipt_expiration_start_date_d: '',

            receipt_expiration_end_date: '',
            receipt_expiration_end_date_y: '',
            receipt_expiration_end_date_m: '',
            receipt_expiration_end_date_d: '',

            url_publish_time_from: '',
            url_publish_time_from_y: '',
            url_publish_time_from_m: '',
            url_publish_time_from_d: '',
            circulation_number_from: '',
            up_manufacturers_from: '',

            url_publish_time_to: '',
            url_publish_time_to_y: '',
            url_publish_time_to_m: '',
            url_publish_time_to_d: '',

            prize_shipping_period: '',
            prize_shipping_period_y: '',
            prize_shipping_period_m: '',
            prize_shipping_period_d: '',
            campaign_create_date: '',
            campaign_create_date_y: '',
            campaign_create_date_m: '',
            campaign_create_date_d: '',
            campaign_start_date_time: '',
            campaign_start_date_time_y: '',
            campaign_start_date_time_m: '',
            campaign_start_date_time_d: '',
            campaign_start_date_time_full_time: '',
            campaign_end_date_time: '',
            campaign_end_date_time_y: '',
            campaign_end_date_time_m: '',
            campaign_end_date_time_d: '',
            campaign_end_date_time_full_time: '',
            secretariat_start_date_time: '',
            secretariat_start_date_time_y: '',
            secretariat_start_date_time_m: '',
            secretariat_start_date_time_d: '',
            secretariat_start_date_time_full_time: '',
            secretariat_end_date_time: '',
            secretariat_end_date_time_y: '',
            secretariat_end_date_time_m: '',
            secretariat_end_date_time_d: '',
            secretariat_end_date_time_full_time: ''
        };
    },

    getDateTo() {
        return {
            total_win_to: '',
            total_inquiry_to: '',
            quantity_for_event_prize: '',
            number_of_win_prize: '',
            total_application_to: '',
            campaign_start_date: '',
            campaign_start_date_y: '',
            campaign_start_date_m: '',
            campaign_start_date_d: '',

            campaign_end_date: '',
            campaign_end_date_y: '',
            campaign_end_date_m: '',
            campaign_end_date_d: '',

            secretariat_start_date: '',
            secretariat_start_date_y: '',
            secretariat_start_date_m: '',
            secretariat_start_date_d: '',

            secretariat_end_date: '',
            secretariat_end_date_y: '',
            secretariat_end_date_m: '',
            secretariat_end_date_d: '',

            receipt_expiration_start_date: '',
            receipt_expiration_start_date_y: '',
            receipt_expiration_start_date_m: '',
            receipt_expiration_start_date_d: '',

            receipt_expiration_end_date: '',
            receipt_expiration_end_date_y: '',
            receipt_expiration_end_date_m: '',
            receipt_expiration_end_date_d: '',

            url_publish_time_from: '',
            url_publish_time_from_y: '',
            url_publish_time_from_m: '',
            url_publish_time_from_d: '',

            url_publish_time_to: '',
            url_publish_time_to_y: '',
            url_publish_time_to_m: '',
            url_publish_time_to_d: '',
            circulation_number_to: '',
            up_manufacturers_to: '',

            prize_shipping_period: '',
            prize_shipping_period_y: '',
            prize_shipping_period_m: '',
            prize_shipping_period_d: '',
            campaign_create_date: '',
            campaign_create_date_y: '',
            campaign_create_date_m: '',
            campaign_create_date_d: '',
            campaign_start_date_time: '',
            campaign_start_date_time_y: '',
            campaign_start_date_time_m: '',
            campaign_start_date_time_d: '',
            campaign_start_date_time_full_time: '',
            campaign_end_date_time: '',
            campaign_end_date_time_y: '',
            campaign_end_date_time_m: '',
            campaign_end_date_time_d: '',
            campaign_end_date_time_full_time: '',
            secretariat_start_date_time: '',
            secretariat_start_date_time_y: '',
            secretariat_start_date_time_m: '',
            secretariat_start_date_time_d: '',
            secretariat_start_date_time_full_time: '',
            secretariat_end_date_time: '',
            secretariat_end_date_time_y: '',
            secretariat_end_date_time_m: '',
            secretariat_end_date_time_d: '',
            secretariat_end_date_time_full_time: ''
        };
    },

    getFilter() {
        return {
            code: '',
            form_url: '',
            advertising_activity_id: [],
            social_platform_id: [],
            campaign_type: '',
            categories: [],
            application_condition_1: {},
            application_condition_2: {},
            sale_staff: [],
            progress_status: [],
            person_in_charge: [],
            project_management: [],
            customer_team_pic: [],
            customer_sub_person: [],
            part_time_employee: [],
            order_scope_large: [],
            order_scope_department: [],
            order_scope_inquiry: [],
            order_scope_inquiry_detail: [],
            order_scope_application: [],
            order_scope_application_detail: [],
            order_scope_secretariat: [],
            order_scope_secretariat_detail: [],
            order_scope_sns_account: [],
            order_scope_sns_account_detail: [],
            order_scope_shipping: [],
            order_scope_shipping_detail: [],
            order_scope_production: [],
            order_scope_production_detail: [],
            scope_partner_inquiry: [],
            scope_partner_application: [],
            scope_partner_secretariat: [],
            scope_partner_shipping: [],
            tool: [],
            prize_type: [],
            prize_type_detail: [],
            purchase_conditions: [],
            responsible_sub_persons: [],
            direction_staff: [],
            is_before_due_date: [],
            is_post_effective_date: [],
            year_end_holiday: [],
            give_away_related: [],
            target_product_list_1: [],
            target_product_list_2: [],
            information_ip: [],
            information_ip_detail: [],
            sponsor_information: [],
            client_order_source_type: [],
            client_generate_file_type: [],
            created_by: ''
        };
    },

    getHas() {
        return {
            client: '',
            client_pic: '',
            contact_information: [],
            partner: isRolePartner() ? getInfoUserLocalStorage().partner_id ?? '' : ''
        };
    },

    getParamsQuery() {
        return {
            is_approved: '',
            team: '',
            sale_staff_team: '',
            progress_status: '',
            partner: '',
            person_in_charge_team: '',
            person_in_charge_role: '',
            sale_or_direction_staff: '',
            part_time_employee: ''
        };
    },

    getNumberQuery() {
        return {
            client: '',
            partner: ''
        };
    },

    getConfigKeyword() {
        return {
            arrayTag: [],
            placeholder:
                'キャンペーン名　発注元　エンドクライアント　営業担当　ディレクションメイン担当　ディレクションサブ1担当＆2担当　賞品種類　...',
            isShowLable: true,
            removeOnDelete: true
        };
    }
};

export { configHelperCampaign };
